const defaultMigratedApiPrefixes = [];

// Re-enable these prefixes gradually after the BFF auth rollout is stable.
// const migratedApiPrefixesBacklog = [
//     "/api/adplist",
//     "/api/admin/color-palettes",
//     "/api/background-library",
//     "/api/cancel-reasons",
//     "/api/color-palettes",
//     "/api/fake-door",
//     "/api/fontpairs",
//     "/api/job-fit-checks",
//     "/api/jobs",
//     "/api/notifications",
//     "/api/referral",
//     "/api/section-presets",
//     "/api/settings/copy",
//     "/api/settings/imageIdeas",
//     "/api/settings/spam-filters",
//     "/api/settings/survey-modal",
//     "/api/support-survey",
// ];

function getMigrationConfig() {
    return window.UXFOLIO_API_MIGRATION_CONFIG || {};
}

function trimTrailingSlash(value) {
    return value.replace(/\/+$/, "");
}

function getBaseUrl() {
    const configuredBaseUrl = getMigrationConfig().baseUrl;

    if (typeof configuredBaseUrl !== "string") {
        return "";
    }

    return trimTrailingSlash(configuredBaseUrl.trim());
}

export function getMigratedApiPrefixes() {
    const configuredPrefixes = getMigrationConfig().prefixes;

    if (!Array.isArray(configuredPrefixes)) {
        return defaultMigratedApiPrefixes;
    }

    const normalizedPrefixes = configuredPrefixes
        .filter((prefix) => typeof prefix === "string" && prefix.trim())
        .map((prefix) => `/${prefix.trim().replace(/^\/+/, "").replace(/\/+$/, "")}`);

    return normalizedPrefixes.length ? normalizedPrefixes : defaultMigratedApiPrefixes;
}

export function isMigratedApiRequest(url) {
    if (!url) {
        return false;
    }

    const requestUrl = new URL(url, window.location.origin);

    return getMigratedApiPrefixes().some((prefix) =>
        requestUrl.pathname === prefix || requestUrl.pathname.startsWith(`${prefix}/`)
    );
}

export function resolveMigratedApiUrl(url) {
    const baseUrl = getBaseUrl();

    if (!shouldRouteMigratedApiRequest(url)) {
        return url;
    }

    const requestUrl = new URL(url, window.location.origin);

    if (requestUrl.origin !== window.location.origin) {
        return url;
    }

    const migrationBaseUrl = new URL(`${baseUrl}/`);
    const migrationBasePath = trimTrailingSlash(migrationBaseUrl.pathname);

    return `${migrationBaseUrl.origin}${migrationBasePath}${requestUrl.pathname}${requestUrl.search}${requestUrl.hash}`;
}

export function shouldRouteMigratedApiRequest(url) {
    return Boolean(getBaseUrl()) && isMigratedApiRequest(url);
}
